export default "__VITE_ASSET__dc24b34a__"